import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useMakeSelector, useSelector } from 'hooks/redux'
import { getUserSetting } from 'selectors/user'
import USER_SETTINGS from 'constants/userSettings'
import { DASH_VIEW, LIST } from 'utils/constants'
import {
  DEFAULT_DRAWER_WIDTH,
  SWGA_BUILDER_INVENTORY_WIDTH,
} from 'utils/drawerConstants'
import { useDispatch } from 'react-redux'
import { setDrawerVisibleWidth, setDrawerWidth } from 'actions/drawer'
import { makeComponentMetaSelector } from 'selectors/navigator'
import Navigator from './Navigator'

const DashDrawer = () => {
  const dispatch = useDispatch()

  const isBuilderDrawerSetToExtendedWidth = useSelector(
    getUserSetting,
    USER_SETTINGS.BUILDER_DRAWER_EXTENDED_WIDTH
  )
  const { view = LIST } =
    useMakeSelector(makeComponentMetaSelector, {
      id: DASH_VIEW,
    }) || {}
  const showExtendedDrawer = view === LIST && isBuilderDrawerSetToExtendedWidth
  const drawerWidth = showExtendedDrawer
    ? SWGA_BUILDER_INVENTORY_WIDTH
    : DEFAULT_DRAWER_WIDTH

  useEffect(() => {
    dispatch(setDrawerWidth(drawerWidth)) // adding setDrawerWidth function as dep causes endless loop
    dispatch(setDrawerVisibleWidth(drawerWidth))
  }, [drawerWidth]) // eslint-disable-line react-hooks/exhaustive-deps

  return <Navigator />
}

export default DashDrawer

DashDrawer.propTypes = {
  showTab: PropTypes.bool,
}
